export const HOME = "home";
export const NEW_OBJECT = "newObject";
export const EDIT_OBJECT = "editObject";
export const MOVE = "move";
export const REFRESH_MULTI = "refreshMulti";
export const NEW_DOCUMENT = "newDocument";
export const EDIT_DOCUMENT = "editDocument";
export const DETAILS_DOCUMENT = "detailsDocument";
export const DOCUMENTS_LISTS = "documentsList";
export const TEMPLATE = "template";
export const DOCUMENT_PROPERTIES = "documentProperties";
export const SETTINGS = "settings";
export const CHOOSECONFIG = "login";
export const SYNCH_RESTORE = "synchRestore";
export const IMPORT = "importDocument";
export const OBJECTS_LIST = "objectsList";
export const UPDATES = "updates";
export const SOURCES = "sources";
export const INFO = "info";
export const IXBRL = "IXBRL";
export const COPY_CUT_PASTE_PANEL_MESSAGE = "COPY_CUT_PASTE_PANEL_MESSAGE";
export const DOWNLOAD_COPY = "DOWNLOAD_COPY";
export const MAINTENANCEMODE = "MAINTENANCEMODE";
